import React from "react"
import { Link, useLocation } from "react-router-dom"
import { Tab } from "./utils"
import "./index.scss"

const isTheSamePath = (currentPath: string, pathname: string) =>
	new RegExp(`^${currentPath}$`).test(pathname)

const isTabSelected = (currentPath: string, pathname: string) =>
	isTheSamePath(currentPath, pathname) ? currentPath : pathname

const getCurrentTabState = (currentPath: string, pathname: string) =>
	isTheSamePath(currentPath, pathname) ? "isCurrent" : ""

interface NavigationTabsProps {
	tabs: Array<Tab>
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({ tabs }) => {
	const { pathname: currentPath } = useLocation()
	return (
		<div className="navigation-tabs">
			{tabs.map(({ text, pathname }, index) => (
				<Link
					key={`navigation-tab-${index}`}
					className={getCurrentTabState(currentPath, pathname)}
					to={isTabSelected(currentPath, pathname)}
				>
					<span>{text}</span>
				</Link>
			))}
		</div>
	)
}

export default NavigationTabs
